import { marketGrowthLegacyRedirectEntries } from "../SLN/market-growth/slnRouteEntries.js";

/** Legacy /partner/commission/* -> /SLN/Partner/* redirects */
export default marketGrowthLegacyRedirectEntries[1];
